import { useCallback } from "react";
import { useUpdateDocumentsCompletedMutation } from "../../graphql/supergraph.index";
import { clientContext } from "../../utils/graphql_utils";

/**
 * A hook that provides functionality for marking documents as complete
 *
 * @param caseId - The ID of the case the documents belong to
 * @param profileId - The ID of the profiles the documents are fore
 */
export default function useUpdateDocumentsCompleted(
  caseId: number | undefined,
  profileId: number | undefined,
) {
  const [updateDocumentsCompleted_, { loading: updateDocumentsCompletedLoading }] =
    useUpdateDocumentsCompletedMutation({
      context: clientContext(),
    });

  const updateDocumentsCompleted = useCallback(async () => {
    if (!caseId) {
      throw new Error("Case ID is required");
    }
    if (!profileId) {
      throw new Error("Profile ID is required");
    }

    await updateDocumentsCompleted_({
      variables: {
        caseId,
        profileId,
        documentsCompleted: true,
      },
      refetchQueries: ["GetComplianceCasesByObjectId"],
    });
  }, [caseId, profileId]);

  return {
    updateDocumentsCompleted,
    loading: updateDocumentsCompletedLoading,
  };
}
